import React, { useState, useEffect } from "react";
import MKBox from "components/MKBox";

// Images
import lucia from "assets/images/etc/lucia_transparent.png";
import lustar from "assets/images/etc/lustar_transparent.png";

const contents = [
  {
    id: 1,
    backgroundImage: lucia,
  },
  {
    id: 2,
    backgroundImage: lustar,
  },
];

function LineUpContents() {
  const [currentSlide, setCurrentSlide] = useState(0);

  // 슬라이드 자동 변경
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % contents.length); // 순환 방식
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <MKBox minHeight="50vh" width="100%" position="relative" overflow="hidden">
      {contents.map((slide, index) => (
        <MKBox
          key={slide.id}
          sx={{
            backgroundImage: `url(${slide.backgroundImage})`,
            backgroundPosition: "center", // 이미지 중앙 배치
            backgroundRepeat: "no-repeat", // 반복 방지
            backgroundSize: "contain", // 비율 유지하며 영역에 맞게
            position: "absolute",
            top: "50%", // 상위 컨테이너의 중심
            left: "50%", // 상위 컨테이너의 중심
            transform: `translate(-50%, -50%) scale(${index === currentSlide ? 1 : 0.8})`, // 조건에 따라 크기 조정
            opacity: index === currentSlide ? 1 : 0,
            transition: "opacity 1s ease, transform 1s ease",
            zIndex: index === currentSlide ? 1 : 0,
            height: { xs: "40vh", sm: "30vh", md: "20vh" }, // 반응형 높이
            width: { xs: "40%", sm: "30%", md: "20%" }, // 반응형 너비
          }}
        ></MKBox>
      ))}
    </MKBox>
  );
}

export default LineUpContents;
